module.exports = __webpack_public_path__ + "static/media/close.7082e21a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MatchRequestModal/close.svg
// module id = 67
// module chunks = 0